import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import * as socketIo from 'socket.io-client';
import {environment} from "../../../environments/environment";
import {ApplicationUser} from "../../services/ApplicationUser";

@Injectable()
export class SocketService {
    public socket: SocketIOClient.Socket;
    
    public config = environment.socket;
    
    constructor(
        public user: ApplicationUser
    ) {

        if (user.getAccessToken()) {
            this.connect(user.getAccessToken());
        }

        user.onAfterLogin.subscribe((res) => {
            this.connect(user.getAccessToken());
        });

        user.onAfterLogout.subscribe((res) => {
            if (this.socket) {
                this.socket.disconnect();
            }
        })
    }

    public connect(token): void {
        this.socket = socketIo(this.config.url + '?token=' + token);
    }

    public emit(event, data): void {
        this.socket.emit(event, data);
    }

    public on(event) : Observable<any> {
        let observable = new Observable(observer => {

            this.socket.on(event, (data) => {
                observer.next(data);
            });
            return () => {
                this.socket.disconnect();
            };
        });
        return observable;
    }

}



// WEBPACK FOOTER //
// ./src/app/models/socket/socket.service.ts